import { SliderProps, Slider, FormHelperText, Box } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { colors } from 'common/constants';

interface BaseSliderProps extends SliderProps {
    name: string;
    endAdornment?: string;
}

const BaseSlider: React.FC<BaseSliderProps> = ({
    name,
    endAdornment,
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <>
                    <Slider
                        {...field}
                        aria-label="slider-custom"
                        valueLabelDisplay="on"
                        {...props}
                    />
                    {endAdornment && (
                        <Box
                            sx={{
                                fontSize: '28px',
                                fontWeight: 500,
                                display: ['none', 'block'],
                            }}
                        >
                            {endAdornment}
                        </Box>
                    )}
                    {fieldState.error && (
                        <FormHelperText
                            sx={{
                                fontSize: '14px',
                                marginLeft: 0,
                                color: `${colors.textError} !important`,
                                fontWeight: '400',
                                flexBasis: '100%',
                            }}
                        >
                            {fieldState.error?.message}
                        </FormHelperText>
                    )}
                </>
            )}
        />
    );
};
export default BaseSlider;
